import React, { useState } from 'react';
import { FaPlusCircle } from "react-icons/fa";
import {
    Button,
    Form,
    Input,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function AddFormModal({ categories }) {

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/products/createProduct', data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'Create successfully',
                        duration: 1,
                        onClose: () => form.resetFields()
                    });
                    queryClient.invalidateQueries(['/api/products/findProducts'])
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Create failed!',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate(values))
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }
    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<FaPlusCircle />}
                onClick={() => setOpen(true)}
            >Add</Button>
            <Modal
                open={open}
                title="Add Product"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='addProduct'
                >
                    <Form.Item
                        name="name"
                        label="Product Name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col xs={12}>
                            <Form.Item
                                label="Category"
                                name="category"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select Category"
                                >
                                    {
                                        categories.map(item => <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                label="Price"
                                name="price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={2} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
